module.exports = __webpack_public_path__ + "static/media/Logo_LPDF_2016.c1cdb00b.jpg";